import StripeCheckoutSuccess from './StripeCheckoutSuccess';

export default StripeCheckoutSuccess;
